import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-horse-shoe",
  "use": "icon-si-glyph-horse-shoe-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-horse-shoe\" id=\"icon-si-glyph-horse-shoe\"><title>1038</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M7.502,1.042 C2.957,1.042 0.078,5.278 0.078,10.504 C0.078,12.909 1.601,16.058 2.323,16.769 C3.046,17.48 4.647,15.947 4.373,15.446 C3.772,14.342 3.359,12.968 3.359,11.477 C3.359,7.83 4.964,4.873 7.502,4.873 C10.037,4.873 11.644,7.83 11.644,11.477 C11.644,12.963 11.234,14.332 10.633,15.434 C10.361,15.941 12.102,17.453 12.678,16.769 C13.255,16.085 14.925,12.91 14.925,10.504 C14.925,5.278 12.045,1.042 7.502,1.042 L7.502,1.042 Z\" fill=\"#434343\" class=\"si-glyph-fill\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-horse-shoe.svg
// module id = ZDpu
// module chunks = 62